export default {
  en: {
    offline: 'Offline',
    online: 'Online',
  },
};
